var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconsMobileMove(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 52.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #202346;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d3343f;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16.04,
    cy: 23.98,
    r: 3.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.5 20.76 7.18 20.81 6.9 14.75 12.95 15.04 12.9 16.36 9.25 16.17 13.52 20.44 12.58 21.37 8.32 17.11 8.5 20.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.11 28.01 6.79 27.97 6.5 34.02 12.56 33.73 12.51 32.41 8.86 32.6 13.12 28.33 12.19 27.4 7.92 31.67 8.11 28.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "19.8 14.96 19.84 16.28 23.5 16.09 19.23 20.36 20.16 21.29 24.43 17.02 24.24 20.68 25.56 20.72 25.85 14.67 19.8 14.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.76,24.96l7.66,7.66-2.97.48c-.67.11-1.21.6-1.38,1.26-.23.91.32,1.84,1.23,2.07l6.25,1.59c2.19.58,4.53.1,6.31-1.3.2-.16.39-.33.57-.51,2.76-2.76,2.76-7.23,0-9.99l-3.2-3.2c-.71-.71-1.6-.73-2.15-.18l-.02.02c-.53.52-.53,1.38,0,1.9l-.92-.92c-.53-.53-1.38-.53-1.9,0l-.02.02s0,0,0,0c-.54.54-.54,1.42,0,1.96l-.88-.88c-.51-.52-1.33-.58-1.9-.13-.04.03-.07.06-.1.09-.54.54-.54,1.42,0,1.96l-4.24-4.24c-.64-.64-1.68-.64-2.33,0-.64.64-.64,1.68,0,2.33Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconsMobileMove);
export default __webpack_public_path__ + "static/media/help_icons_mobile_move.e468110fb7626a7e3d12b13e6f788783.svg";
export { ForwardRef as ReactComponent };